<template>
      <div class="footercom">
            <div class="footertop flex-around">
                  <!-- <img @click="goPage('/index/index')" class="logoimg" :src="appInfo.logo" alt=""> -->
                  <div @click="goPage('/index/rules?type=3')" class="fotext point">关于我们</div>
                  <!-- <div @click="goPage('/index/myService?current=3')" class="fotext point">意见反馈</div>
                  <div @click="goPage('/index/rules?type=1')" class="fotext point">用户协议</div>
                  <div @click="goPage('/index/rules?type=2')" class="fotext point">隐私政策</div> -->
            </div>
            <div class="footerbtm text-center">
                  COPYRIGHT © 2024 辽ICP备19018558号
            </div>
      </div>
</template>
<script>
export default {
      data() { return {} },
      methods: {
            goPage(path) {
                  this.$router.push({
                        path
                  })
            }
      }
}
</script>
<style lang="scss">
.footercom {
      background: #333;
      color: #fff;

      // padding: 0 15%;
      .footerbtm {
            line-height: 40px;
            height: 40px;
            background: #282828;
            font-size: 12px;
            color: #FFFFFF;

      }

      .footertop {
            align-items: flex-start;
            // padding: 20px 420px;
            padding: 50px;

            .fotext {
                  font-size: 14px;
                  line-height: 22px;
                  color: #e6e6e6;
            }

            .logoimg {
                  // width: 144px;
                  // height: 94px;
                  width: 94px;
                  border-radius: 10px;
            }
      }
}
</style>
